/**
 * @author Di Wang
 */
import { message } from 'antd';

message.config({
  top: 50,
  maxCount: 5,
});
